import './ProductGroupList.less';
import { useEffect, useState } from 'preact/hooks';
import type { ProductGroup } from '../../../models/ProductGroup';
import useAppDispatch from '../../../hooks/useAppDispatch';
import ProductSearchSectionHeader from '../../main/search/ProductSearchSectionHeader';
import ProductGrid from './ProductGrid';
import { dispatchEvent } from '../../../services/EventService';

export type ProductGroupListProps = {
    productGroups: ProductGroup[];
    source: 'brilliant' | 'web';
    featureType:
        | 'product-search-combinations'
        | 'product-search-combinations-by-image';
};

const ProductGroupList = ({
    productGroups,
    source,
    featureType
}: ProductGroupListProps) => {
    const dispatch = useAppDispatch();
    const [isTemporaryHidden, setTemporaryHidden] = useState(false);
    useEffect(() => {
        setTemporaryHidden(true);
        const timeout = setTimeout(() => {
            setTemporaryHidden(false);
        }, 10);
        return () => {
            clearTimeout(timeout);
        };
    }, [productGroups]);
    if (isTemporaryHidden) {
        return null;
    }
    return (
        <div className="bri-ProductGroupList">
            {productGroups
                .filter(group => group.products.length > 0)
                .map((group, groupIndex) => {
                    const { title, subtitle, subtitleFeatureOptions } = group;
                    return (
                        <div
                            className={'bri-ProductGroupList-item'}
                            data-bri-product-group-title={title}
                        >
                            {title && (
                                <ProductSearchSectionHeader
                                    title={title}
                                    subtitle={subtitle}
                                    visibleQuantity={group.products.length}
                                    totalQuantity={group.totalQuantity}
                                    onClickSubtitle={
                                        subtitleFeatureOptions
                                            ? event => {
                                                  event.preventDefault();
                                                  if (!subtitleFeatureOptions) {
                                                      return;
                                                  }
                                                  void dispatch.featureState.startFeature(
                                                      subtitleFeatureOptions
                                                  );
                                                  dispatchEvent({
                                                      type: 'bri.click_view_more_products',
                                                      isInteraction: true,
                                                      ...(source === 'brilliant'
                                                          ? {
                                                                source,
                                                                brilliantSource:
                                                                    'ui'
                                                            }
                                                          : { source }),
                                                      featureType:
                                                          subtitleFeatureOptions.featureType
                                                  });
                                              }
                                            : undefined
                                    }
                                />
                            )}
                            <ProductGrid
                                products={group.products}
                                animationDelayStep={50}
                                animationDelayOffset={groupIndex * 100}
                                source={source}
                                featureType={featureType}
                            />
                        </div>
                    );
                })}
        </div>
    );
};

export default ProductGroupList;
